export default function FishFinder(props: any) {
    return (
        <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M24.3098 40.6899C33.5397 40.6899 41.022 33.2077 41.022 23.9778C41.022 14.7479 33.5397 7.26562 24.3098 7.26562C15.0799 7.26562 7.59766 14.7479 7.59766 23.9778C7.59766 33.2077 15.0799 40.6899 24.3098 40.6899Z"
                stroke="white"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.2744 34.1836C29.9316 34.1836 34.5176 29.5976 34.5176 23.9404C34.5176 18.2833 29.9316 13.6973 24.2744 13.6973C18.6173 13.6973 14.0312 18.2833 14.0312 23.9404C14.0312 29.5976 18.6173 34.1836 24.2744 34.1836Z"
                stroke="white"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M24.332 6V19.5" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M42.332 24H28.832" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M24.332 28.5V42" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.832 24H6.33203" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M24.3301 27.3945C26.2706 27.3945 27.8437 25.8481 27.8437 23.9404C27.8437 22.0328 26.2706 20.4863 24.3301 20.4863C22.3895 20.4863 20.8164 22.0328 20.8164 23.9404C20.8164 25.8481 22.3895 27.3945 24.3301 27.3945Z"
                stroke="white"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
